<span
  class="inline-block font-base font-bold leading-5 text-sm px-2 rounded-xm"
  [ngClass]="
    dark ? 'text-neutral-700 bg-neutral-200 lg:bg-neutral-300' : 'text-white bg-primary-600'
  "
>
  {{ quantity }}×
</span>
